import React, { useState, useEffect } from 'react';
import { Route, Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import routes from '../../routes';
import { getBreadcrumbs } from '../../utils/Api';

const tables = {
  mytrainings: 'training',
  lessons: 'lesson',
  chats: 'chat',
};

const getPaths = pathname => {
  const paths = ['/'];
  if (pathname === '/') return paths;

  pathname.split('/').reduce((prev, curr) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);
    return currPath;
  });

  return paths;
};

const findRouteName = url => routes[url]
  || routes[url.split('/').map(path => (path && Number.isInteger(+path) ? ':id' : path)).join('/')];

const BreadcrumbsComponent = ({ intl, location: { pathname } }) => {
  const [names, setNames] = useState({});
  const [ids, setIds] = useState({});

  const getNames = () => {
    const result = {};
    const fields = {};

    pathname.split('/').reduce((previous, current) => {
      if (Number.isInteger(+current))
        result[`${previous}/${current}`] = {
          id: +current,
          name: tables[previous.split('/').slice(-1)[0]],
        };

      return `${previous}/${current}`;
    });
    setIds(result);

    Object.keys(result).forEach((key) => {
      fields[result[key].name] = result[key].id;
    });
    if (Object.keys(fields).length) {
      getBreadcrumbs(fields).then(({ breadcrumb_names }) => { setNames(breadcrumb_names); });
    } else {
      setNames({})
    }
  };

  useEffect(() => {
    getNames();
  }, []);

  const BItem = ({ match: { url, isExact } }) => {
    const routeName = findRouteName(url);
    if (routeName === undefined) return null;

    return isExact ? (
      <BreadcrumbItem active>
        {routeName && !ids[url] && <FormattedMessage id={routeName} />}
        {ids[url] && names[ids[url].name] && (names[ids[url].name].length > 24
          ? `${names[ids[url].name].substr(0, 24)}...`
          : names[ids[url].name])}
      </BreadcrumbItem>
    ) : (
      <BreadcrumbItem>
        <Link to={url || ''}>
          {routeName && !ids[url] && <FormattedMessage id={routeName} />}
          {ids[url] && names[ids[url].name] && (names[ids[url].name].length > 24
            ? `${names[ids[url].name].substr(0, 24)}...`
            : names[ids[url].name])}
        </Link>
      </BreadcrumbItem>
    );
  };

  const paths = getPaths(pathname);
  let isNavigationExists = false;
  paths.forEach(path => { if (findRouteName(path) !== undefined) isNavigationExists = true; });
  if (!isNavigationExists) return null;

  return (
    false ? <div></div>: <Breadcrumb
      data-text={`${intl.formatMessage({ id: 'breadcrumb_prefix' })}: `}
    >{paths.map(path => (
      <Route key={path} path={path} component={BItem} />))}
    </Breadcrumb>
  );
};

export default props => <Route path="/:path" component={injectIntl(BreadcrumbsComponent)} {...props} />;



// WEBPACK FOOTER //
// ./src/components/_Breadcrumb/index.js